export default "__VITE_ASSET__BXhG2ZRW__"